
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoInvoiceReceiveDtGrid extends Serenity.EntityGrid<PoInvoiceReceiveDtRow, any> {
        protected getColumnsKey() { return PoInvoiceReceiveDtColumns.columnsKey; }
        protected getDialogType() { return PoInvoiceReceiveDtDialog; }
        protected getIdProperty() { return PoInvoiceReceiveDtRow.idProperty; }
        protected getInsertPermission() { return PoInvoiceReceiveDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoInvoiceReceiveDtRow.localTextPrefix; }
        protected getService() { return PoInvoiceReceiveDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}